import {
    createApiRef,
    DiscoveryApi,
    FetchApi,
} from "@backstage/core-plugin-api";
import { pluginId } from "@internal/backstage-plugin-secret-sharing-common";

export const secretSharingApiRef = createApiRef<SecretSharingApi>({
    id: pluginId,
});

export type SecretRequestObject = {
    recipients: string[];
    name: string;
    content: string;
    fileName: string;
};

// Defines API interface.
export interface SecretSharingApi {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    createSecret(secret: any): Promise<Response>;

    getReceivedSecrets(): Promise<Response>;

    getSentSecrets(): Promise<Response>;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getSecret(id: any): Promise<Response>;
}

// API interface implementation.
export class SecretSharingClient implements SecretSharingApi {
    private readonly discoveryApi: DiscoveryApi;
    private readonly fetchApi: FetchApi;

    constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
        this.discoveryApi = options.discoveryApi;
        this.fetchApi = options.fetchApi;
    }

    async createSecret(secret: SecretRequestObject): Promise<Response> {
        const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

        return await this.fetchApi.fetch(`${baseUrl}/`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(secret),
        });
    }

    async getReceivedSecrets(): Promise<Response> {
        const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);
        return await this.fetchApi.fetch(`${baseUrl}/received`);
    }

    async getSentSecrets(): Promise<Response> {
        const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);
        return await this.fetchApi.fetch(`${baseUrl}/sent`);
    }

    async getSecret(id: number): Promise<Response> {
        const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);
        return await this.fetchApi.fetch(`${baseUrl}/${id}`);
    }
}
